/**
 * Utility functions for handling URLs in the application
 */

/**
 * Checks if a URL is absolute (starts with http:// or https://)
 * @param url - The URL to check
 * @returns true if the URL is absolute, false otherwise
 */
export const isAbsoluteUrl = (url: string): boolean => {
  return url.startsWith('http://') || url.startsWith('https://');
};

/**
 * Processes a link URL to ensure it opens correctly
 * @param linkUrl - The link URL to process
 * @returns The processed URL that will open in a new tab
 */
export const processLinkUrl = (linkUrl: string): string => {
  // If it's already an absolute URL, return as is
  if (isAbsoluteUrl(linkUrl)) {
    return linkUrl;
  }

  // If it's a relative URL, make it absolute by prepending the current origin
  // This ensures it opens in a new tab and doesn't append to the current URL
  return `${window.location.origin}${linkUrl}`;
};
